import axiosInstance from "../interceptor/instance";
import axiosMapInstance from "../interceptor/webMapInstance";

const baseUrl = `${process.env.REACT_APP_BASE_URL_WEB_MAP}/site`;

export const filterEdotcoSiteTowers = async (query, cancelToken, pageSize, page) => {
  const url = `${baseUrl}/view-port/${query.countryCode}${query.adL ? "/" + query.adL + "/" + query.adLVal : ""}`;
  
  const requestBody = {
    quarter: `${query.quarter} ${query.year}`,
    status: query.status,
    action: query.action,
    northEast: query.northEast,
    southWest: query.southWest,
    limit: pageSize,
    page: page,
    coordinates: query.coordinates,
    radius: query.radius,
    isDownloadEnabled: query.isDownloadEnabled,
    ...(query.operators && {
      operators: query.operators,
      logic: query.logicGate,
    }),
    ...(query.dataType && {
      dataType: query.dataType,
    }),
    ...(query.connectionType && {
      connectionType: query.connectionType,
    }),
  };

  const response = await axiosMapInstance.post(url, requestBody, {
    cancelToken: cancelToken.token,
    clearCacheEntry: true,
  });

  return response.data;
};

export const filterOperatorSiteTowers = async (query, cancelToken, pageSize, page) => {
  const url = `${baseUrl}/operator/view-port/${query.countryCode}${query.adL ? "/" + query.adL + "/" + query.adLVal : ""}`;

  const requestBody = {
    quarter: `${query.quarter} ${query.year}`,
    operator: query.operator,
    northEast: query.northEast,
    southWest: query.southWest,
    coordinates: query.coordinates,
    radius: query.radius,
    isDownloadEnabled: query.isDownloadEnabled,
    limit: pageSize,
    page: page,
  };

  const response = await axiosMapInstance.post(
    url,
    requestBody,
    {
      cancelToken: cancelToken.token,
      clearCacheEntry: true
    }
  );
  return response.data;
};

export const getTooltipDataForEdotcoTower = async (query) => {
  const response = await axiosMapInstance.get(
    `${baseUrl}/single/${query.countryCode}?quarter=${query.quarter}%20${query.year}&lat=${query.lat}&long=${query.long}`,
    {
      clearCacheEntry: true,
      ...(query.operator && {
        params: { operator: query.operator }
      })
    }
  );
  return response.data;
};

export const filterProposedEdotcoTowers = async (
  query,
  cancelToken,
  pageSize,
  page
) => {
  const url = `${baseUrl}/proposed/view-port/${query.countryCode}${
    query.adL ? "/" + query.adL + "/" + query.adLVal : ""
  }`;

  const requestBody = {
    quarter: `${query.quarter} ${query.year}`,
    status: query.status,
    action: query.action,
    coordinates: query.coordinates,
    radius: query.radius,
    isDownloadEnabled: query.isDownloadEnabled,
    northEast: query.northEast,
    southWest: query.southWest,
    limit: pageSize,
    page: page,
    ...(query.operators && {
      operators: query.operators,
      logic: query.logicGate
    }),
    ...(query.dataType && {
      dataType: query.dataType,
    }),
    ...(query.connectionType && {
      connectionType: query.connectionType,
    }),
  };

  const response = await axiosMapInstance.post(url, requestBody, {
    clearCacheEntry: true,
    cancelToken: cancelToken.token,
  });

  return response.data;
};

export const getAdvancedSiteRefs = async (query) => {
  const pageNum = query?.pageNum || 1
  const pageLimit = query?.pageLimit || 10
  const sortingParams = query?.sortParams || []
  let lastValuesArray = []
  if (query?.advanceSearchKeys.length !== 0) {
    const lastValuesByKeys = {};
    for (const item of query?.advanceSearchKeys) {
      const { key, value } = item;
      lastValuesByKeys[key] = value;
    }

    lastValuesArray = Object.entries(lastValuesByKeys).map(([key, value]) => ({ key, value }));
  }

  const advanceSearchKeys = encodeURIComponent(JSON.stringify(lastValuesArray))
  let sortParameters = (sortingParams.length !== 0) ? encodeURIComponent(JSON.stringify(sortingParams)) : []

  const response = await axiosInstance.get(`${baseUrl}/site-ref-filter/${query.countryCode}${query.adL ? "/" + query.adL + "/" + query.adLVal : ""}?quarter=${query.quarter}%20${query.year}&page=${pageNum}&limit=${pageLimit}&sortParams=${sortParameters}&advanceSearchKeys=${advanceSearchKeys}`)
  return response?.data
}

export const getSiteRefs = async (query) => {
  const pageNum = query?.pageNum || 1
  const pageLimit = query?.pageLimit || 10
  const searchKey = query?.searchKey || ''
  const response = await axiosInstance.get(`${baseUrl}/site-ref-filter/${query.countryCode}${query.adL ? "/" + query.adL + "/" + query.adLVal : ""}?quarter=${query.quarter}%20${query.year}&page=${pageNum}&limit=${pageLimit}&searchKey=${searchKey}`)
  return response?.data
}

export const fetchEdotcoSiteCounts = async (
  query,
  cancelToken
) => {
  const response = await axiosInstance.get(
    `${baseUrl}/count/edotco/${query.countryCode}${
      query.adL ? "/" + query.adL + "/" + query.adLVal : ""
    }?quarter=${query.quarter}%20${query.year}${
      !query.adL
        ? "&northEast=" + query.northEast + "&southWest=" + query.southWest
        : ""
    }&status=${query.status}&action=${query.action}${
      query.connectionType ? `&connectionType=${query.connectionType}` : ""
    }${query.dataType ? `&dataType=${query.dataType}` : ""}`,
    {
      clearCacheEntry: query.adL ? false : true,
      cancelToken: cancelToken.token,
    }
  );
  return response.data;
};

export const fetchOprtSiteCounts = async (
  query,
  cancelToken
) => {
  const response = await axiosInstance.get(
    `${baseUrl}/count/operator/${query.countryCode}${query.adL ? "/" + query.adL + "/" + query.adLVal : ""}?quarter=${query.quarter}%20${query.year}${!query.adL ? "&northEast=" + query.northEast + "&southWest=" + query.southWest : ""}`,
    {
      clearCacheEntry: query.adL ? false : true,
      cancelToken: cancelToken.token
    }
  );
  return response.data;
};